/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Ayoub Mahfoud",
  title: "Hi all, I'm Ayoub",
  subTitle: emoji(
    "A passionate Full Stack Software Engineer 🚀 having an experience of building Web and Mobile applications with JavaScript / Angular / Reactjs / Nodejs / Ionic / Scalajs / Java and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1k0l7pVGjzkkY2U_2HGW3re-VI-dJRtdZ/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/MahfoudAyoub",
  linkedin: "https://www.linkedin.com/in/ayoub-mahfoud-466aa7197/",
  gmail: "ayoub-mahfoud@um5r.ac.ma",
  instagram: "https://www.instagram.com/ayoub_mahfoud_/?fbclid=IwAR29DZMxqTdQNanzJUxGWQB-kwvRNJfDX1GsRQxySYRFnkpdePpRFnAf_6Q",
  facebook: "https://www.facebook.com/ayoub.mahfoud.5264",
  //medium: "https://medium.com/@saadpasta",
  //stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji(
      "⚡ Developing mobile applications using Ionic React Native and solo android apps using Java"
    ),
    emoji("⚡ Experience working on multiple databases such as Mongodb, Sql Server, Firebase, MySQL, Sybase")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Angular",
      fontAwesomeClassname: "fab fa-angular"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "Github",
      fontAwesomeClassname: "fab fa-github"
    }

  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section
const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "National School of Computer Science (ENSIAS), Rabat, Morocco",
      logo: require("./assets/images/ensias.jpg"),
      subHeader: "State engineer diploma/Software engineering",
      duration: "September 2018 - April 2021",
      // desc: "Participated in the research of XXX and published 3 papers.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      schoolName: "CPGE Beni Mellal, Morocco",
      logo: require("./assets/images/cpge.jpg"),
      subHeader: "Preparation for national competitive entrance exams to leading Morocco/French 'grandes écoles', specializing in mathematics and physics.",
      duration: "September 2016 - April 2018",
    },
    {
      schoolName: "Scientific Baccalaureate, Ibn Yassine high school, Khouribga, Morocco",
      logo: require("./assets/images/lycee.jpeg"),
      subHeader: "Bachelor of Science in Mechanical Sciences and Technologies",
      duration: "September 2015 - April 2016",
    }

    
  ]
};

// Your top 3 proficient stacks/tech experience
const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "80%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "60%"
    },
    {
      Stack: "Programming",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section
const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      internship: "",
      company: "Capgemini TS Maroc",
      companylogo: require("./assets/images/caplogo.png"),
      date: "April 2022 – Actuel",
      desc: "",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      role: "Front-end Engineer",
      internship: "",
      company: "Asa techno consulting",
      companylogo: require("./assets/images/asalogo.png"),
      date: "February 2022 – March 2022",
      desc: "Development of applications for a French software company KMS in the insurance domain.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      role: "Full Stack Developer",
      internship: "final year internship",
      company: "IVOLYS",
      companylogo: require("./assets/images/involys.jpeg"),
      date: "March 2021 – July 2021",
      desc: "Developing a web application with the purpose of creating and executing SQL queries graphically.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      role: "Full Stack Developer",
      internship: "Second year internship",
      company: "INTELLCAP",
      companylogo: require("./assets/images/intellcap.jpeg"),
      date: "July 2020 – August 2020",
      desc: "Implementing a technological innovation platform in the form of a social network dedicated to art-fashion."
    },
    {
      role: "Front-End Developer",
      internship: "First year internship",
      company: "AXA Assurance",
      companylogo: require("./assets/images/AXA.png"),
      date: "June 2019 – August 2019",
      desc: "Developing and implementing an application for electronic document management."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */
const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on
const bigProjects = {
  title: "Demo Videos",
  subtitle: "Demonstration video illustrates how some of my projects works by showing they in action.",
  projects: [
    {
      image: require("./assets/images/androidApp.jpg"),
      projectName: "E-commerce android application",
      projectDesc: "",
      footerLink: [
        {
          name: "Open the demo video on google drive",
          url: "https://drive.google.com/file/d/1D0jJ-5H8YcZVC625_UXvHtf8vMmgCJp5/view?usp=sharing"
        }
        //  you can add extra buttons here.
      ]
    },
    /* {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    } */
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc
const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Full Stack Web Development with Angular",
      subtitle:
        "Coursera certifies their successful completion of The Hong Kong University of Science and Technology Full Stack Web Development with Angular Specialization.",
      image: require("./assets/images/hong.png"),
      footerLink: [
        {
          name: "Certification",
          url: "https://www.coursera.org/account/accomplishments/specialization/certificate/TF6QKSAN7Z8Z"
        },
        // {
        //   name: "Award Letter",
        //   url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        // },
        // {
        //   name: "Google Code-in Blog",
        //   url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        // }
      ]
    },

    {
      title: "Programming Foundations with JavaScript, HTML and CSS",
      subtitle: "Coursera certifies their successful completion of Programming Foundations with JavaScript, HTML and CSS.",
      image: require("./assets/images/Duke.png"),
      footerLink: [
        {
          name: "Certification",
          url: "https://www.coursera.org/account/accomplishments/certificate/NG376XYZ4V59"
        }
      ]
    },

    {
      title: "Multiplatform Mobile App Development with Web Technologies: Ionic and Cordova",
      subtitle: "Coursera certifies their successful completion of Multiplatform Mobile App Development with Web Technologies: Ionic and Cordova.",
      image: require("./assets/images/hong.png"),
      footerLink: [
        {
          name: "Certification",
          url: "https://www.coursera.org/account/accomplishments/certificate/8T999YWC89AB"
        }
      ]
    },
    
    {
      title: "Java Programming and Software Engineering Fundamentals",
      subtitle:
        "Coursera certifies their successful completion of Duke University Java Programming and Software Engineering Fundamentals Specialization.",
      image: require("./assets/images/Duke.png"),
      footerLink: [
        {
          name: "Certification",
          url: "https://www.coursera.org/account/accomplishments/specialization/certificate/AXWNGN9MPQ5D"
        }
      ]
    },

    {
      title: "Technical Support Fundamentals",
      subtitle: "Coursera certifies their successful completion of Technical Support Fundamentals.",
      image: require("./assets/images/Google.png"),
      footerLink: [
        {
          name: "Certification",
          url: "https://www.coursera.org/account/accomplishments/certificate/LCJVQEJGNVSN"
        }
      ]
    },

    {
      title: "IoT (Internet of Things) Wireless & Cloud Computing Emerging Technologies",
      subtitle: "Coursera certifies their successful completion of IoT (Internet of Things) Wireless & Cloud Computing Emerging Technologies.",
      image: require("./assets/images/Yonsei.png"),
      footerLink: [
        {
          name: "Certification",
          url: "https://www.coursera.org/account/accomplishments/certificate/J7V3QEJ9KLRQ"
        }
      ]
    },
    {
      title: "Big Data Engineer - Explorer Award 2021",
      subtitle: "",
      image: require("./assets/images/BigMaster.png"),
      footerLink: [
        {
          name: "Digital Badge",
          url: "https://www.credly.com/badges/aee1b4a6-eab0-431b-b18c-b6189979e631/public_url"
        }
      ]
    },
    {
      title: "Big Data Engineer - Explorer Award 2021",
      subtitle: "",
      image: require("./assets/images/BigEx.png"),
      footerLink: [
        {
          name: "Digital Badge",
          url: "https://www.credly.com/badges/aee1b4a6-eab0-431b-b18c-b6189979e631/public_url"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section
const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections
const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section
const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://drive.google.com/file/d/1D0jJ-5H8YcZVC625_UXvHtf8vMmgCJp5/view?usp=sharing"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"), 
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all. I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with web and mobile Development.",
  number: "+212 638 27 18 49",
  email_address: "mahfoud.ayoub.me@gmail.com"
};

// Twitter Section

// const twitterDetails = {
//   userName: "twitter", //Replace "twitter" with your twitter username without @
//   display: true // Set true to display this section, defaults to false
// };

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  // twitterDetails
};
